module.exports = __webpack_public_path__ + "static/media/diploma.dd40ba4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/homepage/diploma.png
// module id = 1511
// module chunks = 0